import { findUserWithEmailApi, getEmailSuggestionsApi, getRequestedListApi, raiseNotificationApi, setStatusOfUserRelApi } from 'Constants';
import { Context } from 'Context/Context';
import ProfesssionalDetailsPopUp from 'Modals/ProfesssionalDetailsPopUp';
import React, { useContext, useEffect, useState } from 'react'

function Associates({setSentReq, profData}) {
    const [associate, setAssociate] = useState("");
    const [foundAssociate, setFoundAssociate] = useState(null);
    const {userDetails, makeApiCallFunc} = useContext(Context);
    const email = userDetails?.email;
    const regex = /@([\w.-]+)$/;
    const match = email.match(regex)[0];
    const [suggestions, setSuggestions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [singleUser, setSingleUser] = useState(null);


    const findAttorney = () => {
        makeApiCallFunc(findUserWithEmailApi,
            {
                findingAssistant: false,
                email: associate + match
            },
            ({data}) =>{ 
                setFoundAssociate(data); 
                console.log(data)
            },
            (data) => console.log(data),

        )
    }
    const sendRequest = () => {
        makeApiCallFunc(setStatusOfUserRelApi,
            {
                userId: foundAssociate?._id,
                assistantId: userDetails?._id,
                status: 0
            },
            (data) => {
                setSentReq(prev => !prev);
                setAssociate('');
                setFoundAssociate(null);
                const notificationObj = {
                    title : "Assistant's request to take actions on your behalf ",
                    is_read : false,
                    sender: userDetails._id,
                    additionalInfo: {url: "/profile/4"},
                    notificationCategory: 0,
                    type: "1",
                    receiver:  foundAssociate?._id,
                    content: "Assistant "+userDetails?.firstName+" "+userDetails?.lastName+" has requested to take actions on your behalf on QuickCaseReview.Com.",
                    }
                makeApiCallFunc(raiseNotificationApi, 
                    notificationObj, 
                        (data) => console.log(data),
                        (error) => console.log(error)
                    )
            },
            (data) => console.log(data),

        )
    }
   
    // useEffect(()=>{
    //     if(associate.length > 3)
    //     {
    //         makeApiCallFunc(getEmailSuggestionsApi, 
    //             {
    //                 term: associate,
    //                 emailDomain: match,
    //                 isAssistant: false
    //             },
    //             ({data}) => {
    //                 setSuggestions(data);
    //             },
    //             (data) => console.log(data),
    //         )
    //     }
        
    // },[associate])
  return (
        <>
        {
            showModal &&
            <>
            <ProfesssionalDetailsPopUp uploadNew={showModal} onClose={() => setShowModal(false)} singleUser={singleUser} profData= {profData}/>
            </>
        }
        
        <div  className='w-full'>

        <div className='w-full flex lg:flex-row flex-col items-center justify-between'>
            <div className="relative mt-2 mr-4 shadow-sm flex items-center w-full">
                <input
                type="text"
                name="email"
                id="email"
                className="italic w-full focus-visible:ring-0 mr-2 bg-gray-50 border-0 py-1 pl-3 text-gray-900 placeholder:text-gray-400"
                placeholder="Email of the attorney"
                onChange={(e)=>{
                    const value = e.target.value;
                    const sanitizedValue = value.replace(/[@]/g, '');
                    setAssociate( sanitizedValue)
                }}
                value = {associate} 
                />
                <div>{match}</div>
                
            </div>
             <div className={(associate.length > 0 ? 'bg-green-600' : 'bg-gray-600') + ' text-white rounded p-2 justify-center flex px-4 mt-4 cursor-pointer text-sm w-[200px]'} onClick={findAttorney}>Find attorney</div>

        </div>
        {/* <div>
            {
                suggestions?.map((item, key) => {
                    return (<div className='p-2 border-b-1'>{item?.email}</div>)
                })
            }
        </div> */}
        {
            foundAssociate ?
            foundAssociate.firstName ? 
            <div className='w-full flex justify-between text-sm bg-gray-100 px-4 py-2 items-center hover:bg-gray-200 cursor-pointer border mt-4 lg:mt-10 '>
               <div className='w-12'> <img src = {foundAssociate.profilePic}/> </div>
               <div className='hidden lg:block'> {foundAssociate.firstName}</div>
               <div className='hidden lg:block'> {foundAssociate.lastName} </div>
               {console.log(foundAssociate)}
               <div className=' text-xs underline text-sky-600' 
               onClick={() => {setSingleUser(foundAssociate); setShowModal(true)}}
               >Full details</div>
               <div className='text-white rounded p-2 px-4 text-xs w-max bg-green-600 ' onClick={sendRequest}>Send request</div>
            </div>
            :
            <div className='w-full flex justify-center text-sm px-4 py-2 items-center  border mt-10 '>Attorney not found</div>
            :
            ''
        }
        </div>
        </>
    )
}


export default Associates;